import React from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import CardComponent from "../CardComponent";
import { ReactComponent as StarTrophyIcon } from "../../assets/star-trophy-icon.svg";
import { useTranslation } from "react-i18next";
import _isEmpty from "lodash/isEmpty";
import { WidgetItem } from "../../interfaces/TournamentsConfig";
import {
  formatTimestampTo,
  TIME_FORMAT_DAY_HOUR_MINUTE,
} from "../../utils/DateUtils";

interface TournamentDetailsCardProps {
  tournament: WidgetItem;
}
const TournamentDetailsCard: React.FC<TournamentDetailsCardProps> = ({
  tournament,
}) => {
  const { t } = useTranslation();
  const {
    registrationStartTime,
    registrationEndTime,
    resultDeclareTime,
    tournamentStartTimeText,
    tournamentEndTimeText,
    tournamentResultOutTimeText,
  } = tournament || {};

  const distribution = [
    {
      label: t("tournamentStarts"),
      value: _isEmpty(tournamentStartTimeText)
        ? formatTimestampTo(registrationStartTime, TIME_FORMAT_DAY_HOUR_MINUTE)
        : tournamentStartTimeText,
    },
    {
      label: t("tournamentCloses"),
      value: _isEmpty(tournamentEndTimeText)
        ? formatTimestampTo(registrationEndTime, TIME_FORMAT_DAY_HOUR_MINUTE)
        : tournamentEndTimeText,
    },
    {
      label: t("resultsOut_nx"),
      value: _isEmpty(tournamentResultOutTimeText)
        ? formatTimestampTo(resultDeclareTime, TIME_FORMAT_DAY_HOUR_MINUTE)
        : tournamentResultOutTimeText,
    },
  ];

  return (
    <>
      <CardComponent
        className={clsx(styles.tournamentDetailsCard, styles.cardWithHeading)}
        borderType="Md"
      >
        <>
          <div
            className={clsx(
              styles.cardHeading,
              "fontSizeSm fontWeightBold fontColorBlack"
            )}
          >
            <StarTrophyIcon />
            {t("tournamentDetails")}
          </div>
          {distribution?.map(({ label, value }, index) => (
            <div className={clsx(styles.detailingRow)} key={index}>
              <div
                className={clsx(
                  styles.valueTitle,
                  "fontWeightMedium fontColorBlack fontSizeSm14"
                )}
              >
                {label}
              </div>
              <div
                className={clsx(
                  styles.value,
                  "fontWeightMedium fontColorBlack fontSizeSm14"
                )}
              >
                {value}
              </div>
            </div>
          ))}
        </>
      </CardComponent>
    </>
  );
};
export default TournamentDetailsCard;
